var slideshowClick = function(slide, el) {
	var $slideshowNav = slide.querySelector('.coto_slideshow-nav');
    
	$slideshowNav.querySelector('.active').classList.remove('active');
    el.classList.add('active');
    
    

};

module.exports = slideshowClick;